import store from '@/core/store'
import { useEffect, useState } from 'react'

import Attachment from './Attachment'

import './AttachmentSection.sass'

export default function MessageAttachments (props) {
  const [draft, setDraft] = useState(props.draft || {})
  
  function hasAttachments () {
    return draft?.attachments?.length > 0
  }

  function generateAttachments () {
    const attachments =
    draft?.attachments?.map((attachment) =>
      (<Attachment key={attachment.filename} draftId={draft.id} attachment={attachment} allAttachments={draft.attachments}/>)
    )
    return attachments
  }

  useEffect(() => {
    setDraft(props.draft)
  }, [props.draft])

  useEffect(() => {
    store.on('DRAFT_MESSAGE:ATTACHMENTS_UPDATED', (draft) => {
      setDraft(draft)
    })
  }, [])

  if (hasAttachments()) {
    return (
      <>
        <div className='message-modal-divider'/>
        <div className='attachments-section'>
          <div className='attachments-section-header'>Attachment(s)</div>
          <div className='attachments-section-main'>{generateAttachments()}</div>
        </div>
      </>
    )
  } return (<></>)
}
